import { render, staticRenderFns } from "./TrainingTrainingsList.vue?vue&type=template&id=7ead670b&"
import script from "./TrainingTrainingsList.vue?vue&type=script&lang=js&"
export * from "./TrainingTrainingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports